/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  HoundsZerocost,
  HoundsZerocostInterface,
  Constructor,
} from "../HoundsZerocost";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "defaultHound",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "externalBreedingFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedingCooldownCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "breedingCooldown",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedingCooldownTimeUnit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refillBreedingCooldownCost",
            type: "uint256",
          },
        ],
        internalType: "struct Hound.ConstructorBreeding",
        name: "breeding",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "staminaRefillCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "staminaRefill1x",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "staminaPerTimeUnit",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCap",
            type: "uint32",
          },
        ],
        internalType: "struct Hound.ConstructorStamina",
        name: "stamina",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "minter",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsModifier",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "shop",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "genetics",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsInitializer",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsRenameHandler",
            type: "address",
          },
        ],
        internalType: "struct ConstructorBoilerplate.Struct",
        name: "boilerplate",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "renameFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "platformBreedFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedTransactionFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformBreedFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedTransactionFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "renameFee",
            type: "uint256",
          },
        ],
        internalType: "struct ConstructorFees.Struct",
        name: "fees",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hound",
        type: "uint256",
      },
    ],
    name: "getBreedCosts",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct MicroPayment.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type HoundsZerocostConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HoundsZerocostConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HoundsZerocost__factory extends ContractFactory {
  constructor(...args: HoundsZerocostConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "HoundsZerocost";
  }

  deploy(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HoundsZerocost> {
    return super.deploy(input, overrides || {}) as Promise<HoundsZerocost>;
  }
  getDeployTransaction(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): HoundsZerocost {
    return super.attach(address) as HoundsZerocost;
  }
  connect(signer: Signer): HoundsZerocost__factory {
    return super.connect(signer) as HoundsZerocost__factory;
  }
  static readonly contractName: "HoundsZerocost";
  public readonly contractName: "HoundsZerocost";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HoundsZerocostInterface {
    return new utils.Interface(_abi) as HoundsZerocostInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HoundsZerocost {
    return new Contract(address, _abi, signerOrProvider) as HoundsZerocost;
  }
}
